"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
require("./locales/i18n");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const global_styles_1 = __importDefault(require("./assets/styles/global-styles"));
const Navbar_1 = require("./components/molecules/Navbar/Navbar");
const index_1 = __importDefault(require("./store/index"));
const MapPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require("./pages/MapPage"))).then((module) => ({ default: module.MapPage })));
const CalendarPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require("./pages/CalendarPage/CalendarPage"))).then((module) => ({
    default: module.CalendarPage,
})));
const NotFoundPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require("./pages/NotFoundPage"))).then((module) => ({
    default: module.NotFoundPage,
})));
const RedirectPage = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require("./pages/RedirectPage"))).then((module) => ({
    default: module.RedirectPage,
})));
const NEW_MAP = "/new_map";
const router = (0, react_router_dom_1.createBrowserRouter)((0, react_router_dom_1.createRoutesFromElements)(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(MapPage, null,
            react_1.default.createElement(Navbar_1.Navbar, { isMapPage: true })) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "/fixed_stream", element: react_1.default.createElement(CalendarPage, null,
            react_1.default.createElement(Navbar_1.Navbar, { isMapPage: false })) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(NotFoundPage, null,
            react_1.default.createElement(Navbar_1.Navbar, { isMapPage: false })) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: NEW_MAP, element: react_1.default.createElement(RedirectPage, null,
            react_1.default.createElement(Navbar_1.Navbar, { isMapPage: false })) }))));
const App = () => {
    return (react_1.default.createElement(react_redux_1.Provider, { store: index_1.default },
        react_1.default.createElement(global_styles_1.default, null),
        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null, "Loading...") },
            react_1.default.createElement(react_router_dom_1.RouterProvider, { router: router }))));
};
exports.App = App;
